// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recover[data-v-1fe83144]{margin-top:calc(var(--spacer)*4)}.recover__reset-form-illustration[data-v-1fe83144]{margin-bottom:calc(var(--spacer-half)*5)}.recover .text-h5[data-v-1fe83144]{color:var(--v-gray-deep-navy);font-size:24px;line-height:28px;letter-spacing:unset;margin-bottom:var(--spacer)}.recover .text-subtitle-1[data-v-1fe83144]{color:var(--v-gray-deep-navy);font-size:16px!important;line-height:24px;letter-spacing:.5px!important;margin-bottom:calc(var(--spacer)*2)}", ""]);
// Exports
module.exports = exports;
